import type { FirebaseApp } from 'firebase/app';
import type { Auth as AuthType } from 'firebase/auth';

import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

import { CONFIG } from 'src/config-global';

// ----------------------------------------------------------------------

const isFirebase = CONFIG.auth.method === 'firebase';

export const firebaseApp = isFirebase ? initializeApp(CONFIG.firebase) : ({} as FirebaseApp);

export const AUTH = isFirebase ? getAuth(firebaseApp) : ({} as AuthType);
